
//Mexico
export const validateCLABE = (clabe) => {
  const regex = /^\d{18}$/;
  return regex.test(clabe);
};

export const validateRFC = (rfc) => {
  const regex = /^([A-ZÑ&]{3}|[A-ZÑ&]{4})\d{6}[A-Z0-9]{3}$/;
  return regex.test(rfc);
};

//Republica
export const validateRNC = (rnc) => {
  const regex = /^\d{9}$/;
  return regex.test(rnc);
};

export const validateAccountNumber = (accountNumber) => {
  const regex = /^\d{12}$/;
  return regex.test(accountNumber);
};

export const validateRoutingNumber = (validateRoutingNumber) => {
  const regex = /^\d{3}$/;
  return regex.test(validateRoutingNumber);
};


//Argentina
export const validateCBU = (cbu) => {
  const regex = /^\d{22}$/;
  return regex.test(cbu);
};

export const validateCUIT_CUIL = (cuit) => {
  const regex = /^\d{2}-?\d{8}-?\d{1}$/;
  if (!regex.test(cuit)) return false;

  const cuitNumbers = cuit.replace(/-/g, '').split('').map(Number);
  const multipliers = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];

  let total = 0;
  for (let i = 0; i < multipliers.length; i++) {
    total += cuitNumbers[i] * multipliers[i];
  }

  const mod = 11 - (total % 11);
  const checkDigit = mod === 11 ? 0 : mod === 10 ? 9 : mod;

  return checkDigit === cuitNumbers[10];
};

//Spain
export const validateIBAN = (iban) => {
  const regex = /^ES\d{2}\d{4}\d{4}\d{2}\d{10}$/;
  return regex.test(iban);
};

export const validateNIF = (value) => {
  const nifRexp = /^[0-9]{8}[A-Z]$/i;
  const nieRexp = /^[XYZ][0-9]{7}[A-Z]$/i;
  const str = value.toString().toUpperCase();
  if (nifRexp.test(str) || nieRexp.test(str)) {
    return true;
  }

  return false;
};

//COLOMBIA

export const validateBankAccountColombia = (cuenta) => {
  const unscriptedAccount = cuenta.replace(/-/g, '');
  const regex = /^\d{8,16}$/; 
  return regex.test(unscriptedAccount);
};

export const validateNIT = (nit) => {
  const regex = /^\d{8,9}-?\d{1}$/;
  return regex.test(nit);
};

//US
export const validateRoutingNumberUS = (number) => {
  return /^[0-9]{9}$/.test(number);
};

export const validateAccountNumberUS = (number) => {
  return /^[0-9]{8,12}$/.test(number); 
};


export const validateSsnOrEin = (number) => {
  if (typeof number !== "string") return false;
  const cleanedInput = number.replace(/-/g, "");
  const ssnRegex = /^(?!000|666|9\d{2})\d{3}(?!00)\d{2}(?!0000)\d{4}$/;
  const einRegex = /^(?!00)\d{2}\d{7}$/;
  return ssnRegex.test(cleanedInput) || einRegex.test(cleanedInput);
};

export const validateBusinessName = (businessName) => {
  if (typeof businessName !== "string" || businessName.trim().length < 2 || businessName.trim().length > 100) {
    return false;
  }
  return true;
};